import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getOneBooking, updateBooking } from '../../../slice/bookingSlice';

const Update = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { oneData: booking, loading } = useSelector((state) => state.booking);

    const [status, setStatus] = useState('');

    useEffect(() => {
        dispatch(getOneBooking(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (booking) {
            setStatus(booking.status);
        }
    }, [booking]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(updateBooking({ id, data: { status } }));
        navigate('/khajuraho/bookings');
    };

    if (loading || !booking) {
        return <div className="p-5">Loading booking details...</div>;
    }

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Update Booking Status</h4>
            </div>
            <div className="mt-4 px-4 bg-white rounded shadow-sm py-4 max-w-lg mx-auto">
                <div className="mb-4">
                    <h5>Booking Details</h5>
                    <hr />
                    <p><strong>Name:</strong> {booking.name}</p>
                    <p><strong>Package:</strong> {booking.message}</p>
                    <p><strong>Date:</strong> {booking.travelDate}</p>
                </div>
                
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="bookingStatus">Booking Status</label>
                        <select 
                            id="bookingStatus"
                            className="form-control" 
                            value={status} 
                            onChange={(e) => setStatus(e.target.value)}
                            required
                        >
                            <option value="Pending">Pending</option>
                            <option value="Confirmed">Confirmed</option>
                            <option value="Cancelled">Cancelled</option>
                            <option value="Completed">Completed</option>
                        </select>
                    </div>
                    <div className="mt-4">
                        <button type="submit" className="btn btn-primary px-5 mr-3">Update Status</button>
                        <button type="button" className="btn btn-secondary" onClick={() => navigate('/khajuraho/bookings')}>Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Update;
